import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// error pages
import AccessDenied from '@/layout/errors/AccessDenied'
import NotFound from '@/layout/errors/NotFound'
import GeneralError from '@/layout/errors/Error'

Vue.use(Router)
let contRequests = 0
const router = new Router({
  mode: 'history',
  base: '/arrecadacao/',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    /*{
      path: '/',
      name: 'inicial',
      component: () => import('@/views/home/Home.vue'),
      meta: {
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/info',
      name: 'Informações',
      component: () => import('@/layout/info/Info'),
      meta: {
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/Home.vue'),
      meta: {
        breadcrumb: true,
        label: 'Página Inicial',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/ajuda',
      name: 'ajuda',
      component: () => import('@/views/Ajuda/Ajuda.vue'),
      meta: {
        breadcrumb: true,
        label: 'Ajuda',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/consultar/pagamento',
      name: 'ConsultarPagamento',
      component: () => import('@/views/ConsultarPagamento/ConsultarPagamento.vue'),
      meta: {
        breadcrumb: true,
        label: 'Consultar Pagamento',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/consultar/espelho/grpr',
      name: 'ConsultarEspelho',
      component: () => import('@/views/ConsultarEspelho/ConsultarEspelho.vue'),
      meta: {
        breadcrumb: true,
        label: 'Consultar Espelho',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/consultar/autenticacao',
      name: 'ConsultarAutenticacao',
      component: () => import('@/views/ConsultarAutenticacao/ConsultarAutenticacao.vue'),
      meta: {
        breadcrumb: true,
        label: 'Consultar Autenticacao',
        requiresAuth: false,
        groups: []
      }
    },*/
    {
      path: '/emitir/guiatela',
      name: 'guiatela',
      component: () => import('@/views/EmitirGuia/EmitirGuia.vue'),
      meta: {
        breadcrumb: true,
        label: 'Emitir Guia',
        requiresAuth: false,
        groups: [],
        cont: 0
      }
    },
    {
      path: '/arearestrita/emitir/guiatela',
      name: 'guiatelaarearestrita',
      component: () => import('@/views/EmitirGuia/EmitirGuia.vue'),
      meta: {
        breadcrumb: true,
        label: 'Emitir Guia',
        requiresAuth: true,
        groups: [],
        cont: 0
      }
    },
    {
      path: '/emitir/guia',
      name: 'EmitirGuia',
      component: () => import('@/views/EmitirGuia/components/redirect.vue'),
    },
    /*{
      path: '/emitir/guia/passo2',
      name: 'EmitirGuiaPasso2',
      component: () => import('@/views/EmitirGuia/components/EmitirGuiaPasso2.vue'),
      meta: {
        breadcrumb: true,
        label: 'Emitir Guia PAsso 2',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/emitir/guia/passo3',
      name: 'EmitirGuiaPasso3',
      component: () => import('@/views/EmitirGuia/components/EmitirGuiaPasso3.vue'),
      meta: {
        breadcrumb: true,
        label: 'Emitir Guia PAsso 3',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/emitir/parcelamento',
      name: 'EmitirGuiaParcelamento',
      component: () => import ('@/views/EmitirGuiaParcelamento/EmitirGuiaParcelamento.vue'),
      meta: {
        breadcrumb: true,
        label: 'Emitir Guia Parcelamento',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/emitir/autoinfracao',
      name: 'EmitirGuiaAutoInfracao',
      component: () => import('@/views/EmitirGuiaAutoInfracao/EmitirGuiaAutoInfracao.vue'),
      meta: {
        breadcrumb: true,
        label: 'Emitir Guia Auto Infracao',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/retificar/grprgnre',
      name: 'RetificarGrprGnre',
      component: () => import('@/views/RetificarGrprGnre/RetificarGrprGnre.vue'),
      meta: {
        breadcrumb: true,
        label: 'Retificar GRPR e GNRE',
        requiresAuth: false,
        groups: []
      }
    },
    {
      path: '/guia',
      name: 'Guia',
      component: () => import('@/views/shared/Guia/Guia.vue'),
      meta: {
        requiresAuth: false
      }
    },*/
    {
      path: '/negado',
      name: 'AccessDenied',
      component: AccessDenied,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/erro',
      name: 'GeneralError',
      component: GeneralError,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/naoencontrado',
      name: 'NotFound',
      component: NotFound,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/*',
      name: 'NotFound',
      components: {
        secundario: NotFound,
        default: NotFound
      },
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('message/setMessages', null)
  store.dispatch('layout/setLayout', 'admin')
  next()
})

export default router
